import React from 'react';
import { AuthProvider } from './AuthContext';
import { ThemeProvider } from './ThemeContext';
import { SchoolProvider } from './SchoolContext';
import { DistrictProvider } from './DistrictContext';
import { RegionProvider } from './RegionContext';
import { AdminProvider } from './AdminContext';
import { RateProvider } from './RateContext';
import { RelationshipProvider } from './RelationshipContext';
import { StudentProvider } from './StudentContext';
import { ContactProvider } from './ContactContext';
import { StationProvider } from './StationContext';
import { CardProvider } from './CardContext';
import { CallProvider } from './CallContext';


const SuperProvider=(props)=>{
  
  return (
    <ThemeProvider>
      <AuthProvider>
        <SchoolProvider>
          <DistrictProvider>
            <RegionProvider>
              <AdminProvider>
                <RateProvider>
                  <RelationshipProvider>
                      <StudentProvider>
                        <ContactProvider>
                          <StationProvider>
                            <CardProvider>
                                  <CallProvider>
          
                                      {props.children}
                                  </CallProvider>
                            </CardProvider>
                          </StationProvider>
                        </ContactProvider>
                      </StudentProvider>
                  </RelationshipProvider>
                </RateProvider>
              </AdminProvider>
            </RegionProvider>
          </DistrictProvider>
        </SchoolProvider>
      </AuthProvider>
    </ThemeProvider>                         
  )
}

export default SuperProvider;